import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from 'react';
import { useHistory } from 'react-router-dom';
import RoomContext from '../../services/roomContext';
import { makeStyles } from '@material-ui/core/styles';
import togetherPageStyles from '../../styles/togetherPageStyles';
import useWindowDimensions from '../../theme/useWindowDimensions';
import StreamEvent from '../StreamEvent';
import StadiumBoxes from '../stadiumBoxes';
import VideoChat from '../VideoChat';
import Services from '../../services/services';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import lifecycleEs5 from 'page-lifecycle';
import { useSelector, useDispatch } from 'react-redux';
import CustomButton from '../viewEventUi/CustomButton';
import ChatsContainer from '../chatsContainer';
import toast from 'react-hot-toast';
import SwapVertSharpIcon from '@material-ui/icons/SwapVertSharp';
import KeyboardArrowLeftSharpIcon from '@material-ui/icons/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@material-ui/icons/KeyboardArrowRightSharp';
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
// import AttachMoneySharpIcon from '@material-ui/icons/AttachMoneySharp';
import IconButton from '@material-ui/core/IconButton';

import Donate from './../payments/Donate';
import { setSessionItem, removeSessionItem } from '../../constants';
import CustomModal from '../modal';

import Splitter, { SplitDirection } from '@devbookhq/splitter';
import '../../styles/dragGutterStyles.css';

import { groupIcon } from '../icons';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Tour from 'reactour';

import {
  // selectChat,
  // setChatsHidden,
  updateActiveChatAndHiddenStatus,
  updateParticipantList,
} from '../../redux/chatSelectSlice';
import { updateTour } from '../../redux/watcheventTourSlice';
// import { updateEventStatus } from '../../redux/eventStatusSlice';
import { checkEventStatus } from '../eventTabs/funcCalls';

const useStyles = (windowDims) =>
  makeStyles((theme) => togetherPageStyles(theme, windowDims));

// const useStyles = makeStyles((theme) => togetherPageStyles(theme));

function Layout({ url, userId, eventId }) {
  const accentColor = '#5cb7b7';

  const [zindex, setZindex] = useState({ zIndex: '0' });
  const [displayBlock, setDisplayBlock] = useState({ display: 'block' });
  const [displayNone, setDisplayNone] = useState({ display: 'none' });
  const { height, width } = useWindowDimensions();
  const classes = useStyles({
    height,
    width,
    zindex,
    displayBlock,
    displayNone,
  })();
  const history = useHistory();
  const eventTimerID = useRef();
  const dispatch = useDispatch();
  const movingBox = useSelector((state) => state.movingBox);
  const chatSelect = useSelector((state) => state.chatSelect);
  const boxChat = useSelector((state) => state.boxChat);
  const globalChat = useSelector((state) => state.globalChat);
  const eventStatus = useSelector((state) => state.eventStatus);
  const watchEventTour = useSelector((state) => state.watcheventTour);
  const eventTimerLevel = 10000;

  const paymentRef = useRef(null);
  const [paymentEle, setPaymentEle] = useState(false);
  // const [videoGrid, setVideoGrid] = useState(8);
  const { rooms, setRooms } = useContext(RoomContext);
  const [dialog, setDialog] = useState(false);
  const [parentInitialSize, setParentInitialSize] = useState([60, 40]);
  const [childInitialSize, setChildInitialSize] = useState([70, 30]);
  // const [isTourOpen, setIsTourOpen] = useState(true);
  // const [isShowingMore, setIsShowingMore] = useState(false);
  const {
    activeBoxRoom,
    // activeBoxDataTrack,
    activeGConversation,
    activeBConversation,
  } = { ...rooms };

  const browserHandlerFunc = (event) => {
    if (event.newState === 'terminated' || event.newState === 'frozen') {
      exitStream();
    }
  };

  const handleOpenDonate = (event) => {
    setPaymentEle(true);
  };

  const handleCloseDonate = () => {
    setPaymentEle(false);
  };

  const handleShowDialog = () => {
    setDialog(!dialog);
  };

  const handleChatClick = () => {
    if (zindex.zIndex == '0') {
      setZindex({ zIndex: '100' });
    } else if (zindex.zIndex == '100') {
      setZindex({ zIndex: '0' });
    }

    if (displayBlock.display == 'block') {
      setDisplayBlock({ display: 'none' });
    } else if (displayBlock.display == 'none') {
      setDisplayBlock({ display: 'block' });
    }

    if (displayNone.display == 'block') {
      setDisplayNone({ display: 'none' });
    } else if (displayNone.display == 'none') {
      setDisplayNone({ display: 'block' });
    }
  };

  // const handleZindexHide = () => {
  //   setZindex({ zIndex: "0" });
  // };

  const isEventExpired = async (userId, eventId, eventUniqueNo) => {
    const res = await checkEventStatus(userId, eventId, eventUniqueNo);
    if (res.removeUserFromStream === true) {
      toast.success('Event Ended.');
      // dispatch(updateEventStatus({ isInactive: true })); //no need of this anymore
      exitStream();
      return;
    } else {
      retryEventStatusWithTimeInterval();
      return;
    }
  };

  const checkStreamStatus = async () => {
    isEventExpired(
      eventStatus.userId,
      eventStatus.eventId,
      eventStatus.eventUniqueNo
    );
  };

  const clearEventStatusRetryTimeInterval = () => {
    // 'clearing interval', eventTimerID?.current
    clearTimeout(eventTimerID?.current);
  };
  const retryEventStatusWithTimeInterval = () => {
    clearEventStatusRetryTimeInterval();

    // 'timer started', eventTimerID.current
    eventTimerID.current = setTimeout(() => {
      // 'timer running', eventTimerID.current
      checkStreamStatus();
    }, eventTimerLevel);
  };

  const disConnectRooms = () => {
    try {
      clearEventStatusRetryTimeInterval();
      activeBoxRoom?.disconnect();
      activeGConversation?.leave();
      activeBConversation?.leave();
      activeGConversation?.shutdown();
      activeBConversation?.shutdown();
    } catch (error) {
      console.log('error in disconnecting rooms', error);
    }
  };

  const boxMovingSeatAssign = () => {
    removeSessionItem('prevBoxSeatDetails');
    const saveBoxSeat = {
      boxChatChannelSID: movingBox.currBoxChatSid,
      boxId: movingBox.currBoxID,
      boxName: movingBox.currBoxName,
      seatId: movingBox.currSeatID,
    };
    setSessionItem('prevBoxSeatDetails', JSON.stringify(saveBoxSeat));
  };

  const handleRefresh = (event) => {
    event.preventDefault();
    boxMovingSeatAssign();
    disConnectRooms();
  };

  const exitStream = async () => {
    clearEventStatusRetryTimeInterval();
    disConnectRooms();
    const res = await Services.exit_event(userId, eventId);
    if (res.data?.message === 'Success') {
      history.goBack();
      return null;
    }
    toast.error('Try Again!');
  };

  useEffect(() => {
    lifecycleEs5.addEventListener('statechange', browserHandlerFunc);

    return () => {
      lifecycleEs5.removeEventListener('statechange', browserHandlerFunc);
      try {
        activeBoxRoom?.disconnect();
        activeGConversation?.leave();
        activeBConversation?.leave();
        activeGConversation?.shutdown();
        activeBConversation?.shutdown();
      } catch (error) {
        console.log('error in disconnecting rooms', error);
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', handleRefresh);
    return () => {
      window.removeEventListener('beforeunload', handleRefresh);
    };
  }, [movingBox]);

  useEffect(() => {
    retryEventStatusWithTimeInterval();

    return () => {
      clearEventStatusRetryTimeInterval();
    };
  }, []);

  const voteNow = () => {
    window.open(
      'https://accinventureprize.com/peoples-choice-voting',
      '_blank'
    );
  };

  const disableBody = (target) => disableBodyScroll(target);
  const enableBody = (target) => enableBodyScroll(target);

  const closeTour = () => {
    dispatch(updateTour({ status: false }));
  };

  const handleResizeFinishedParent = useCallback((_, newSizes) => {
    setParentInitialSize(newSizes);
  }, []);

  const handleResizeFinishedChild = useCallback((_, newSizes) => {
    setChildInitialSize(newSizes);
  }, []);

  const regularLayoutFunc = () => {
    return (
      <div className={classes.root}>
        <Grid container data-tut='reactour_gutter'>
          <Splitter
            direction={SplitDirection.Horizontal}
            gutterClassName='gutterClassCustom'
            initialSizes={parentInitialSize}
            // draggerClassName="draggerClassCustom"
            onResizeFinished={handleResizeFinishedParent}
          >
            <Grid
              item
              className={classes.transitionEff}
              component='div'
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: height - 1,
              }}
            >
              <Splitter
                direction={SplitDirection.Vertical}
                minHeights={[20, height * 0.06]}
                initialSizes={childInitialSize}
                // onResizeFinished={handleResizeFinishedChild}
              >
                <StreamEvent url={url} />
                <ChatsContainer />
              </Splitter>
              <div
                id='panel1a-header'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#000000',
                  height: height * 0.05,
                  minHeight: '40px',
                }}
              >
                <div
                  style={{ display: 'flex', flexDirection: 'row' }}
                  data-tut='reactour_chat'
                >
                  <div style={{ position: 'relative' }}>
                    {!globalChat?.newMsgCount ? null : (
                      <span
                        style={{
                          position: 'absolute',
                          zIndex: 2,
                          top: 0,
                          right: 0,
                          transform: 'translate(2px,-40%)',
                          width: 15,
                          height: 15,
                          borderRadius: 10,
                          backgroundColor: 'darkcyan',
                        }}
                      ></span>
                    )}
                    <CustomButton
                      btnStyle={
                        chatSelect.globalChatSelect &&
                        !chatSelect.participantList.status
                          ? classes.chatActive
                          : classes.btnInactive
                      }
                      clickHandle={() => {
                        dispatch(
                          updateActiveChatAndHiddenStatus({
                            isGlobalChat: true,
                            areHidden: false,
                          })
                        );
                      }}
                      btnText={'Event Chat'}
                    />
                  </div>
                  <div style={{ position: 'relative' }}>
                    {!boxChat?.newMsgCount ? null : (
                      <span
                        style={{
                          position: 'absolute',
                          zIndex: 2,
                          top: 0,
                          right: 0,
                          transform: 'translate(2px,-40%)',
                          width: 15,
                          height: 15,
                          borderRadius: 10,
                          backgroundColor: 'darkcyan',
                        }}
                      ></span>
                    )}
                    <CustomButton
                      btnStyle={
                        chatSelect.globalChatSelect ||
                        chatSelect.participantList.status
                          ? classes.btnInactive
                          : classes.chatActive
                      }
                      clickHandle={() => {
                        dispatch(
                          updateActiveChatAndHiddenStatus({
                            isGlobalChat: false,
                            areHidden: false,
                          })
                        );
                      }}
                      btnText={'Table Chat'}
                    />
                  </div>
                  <CustomButton
                    btnStyle={
                      chatSelect.participantList.status &&
                      !chatSelect.participantList.isGlobalParticipants
                        ? classes.chatActive
                        : classes.btnInactive
                    }
                    clickHandle={() => {
                      dispatch(
                        updateParticipantList({
                          status: true,
                          isGlobalParticipants: false,
                        })
                      );
                    }}
                    btnText={'Table'}
                    startIcon={groupIcon().icon}
                  />
                  <CustomButton
                    btnStyle={
                      chatSelect.participantList.status &&
                      chatSelect.participantList.isGlobalParticipants
                        ? classes.chatActive
                        : classes.btnInactive
                    }
                    clickHandle={() => {
                      dispatch(
                        updateParticipantList({
                          status: true,
                          isGlobalParticipants: true,
                        })
                      );
                    }}
                    btnText={'Event'}
                    startIcon={groupIcon().icon}
                  />
                </div>
              </div>
            </Grid>

            <Grid
              item
              component='div'
              className={classes.transitionEff}
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: height - 1,
                backgroundColor: '#2B2C33', //#191838 11091E --old
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  height: 0.05 * height,
                }}
              >
                <div ref={paymentRef}></div>
                {/* <CustomButton
                  btnStyle={classes.btnStyleDonate}
                  clickHandle={handleOpenDonate}
                  btnText={'Donate'}
                  startIcon={
                    <AttachMoneySharpIcon className={classes.changeIcon} />
                  }
                /> */}

                {/* <CustomButton
                  btnStyle={classes.btnStyleDonate}
                  clickHandle={voteNow}
                  btnText={'Vote Now'}
                  // startIcon={
                  //   <AttachMoneySharpIcon className={classes.changeIcon} />
                  // }
                /> */}
                <div data-tut='reactour_boxChange'>
                  <CustomButton
                    btnStyle={classes.btnStyle}
                    clickHandle={handleShowDialog}
                    btnText={'Seating Layout'}
                    startIcon={
                      <SwapVertSharpIcon className={classes.changeIcon} />
                    }
                  />
                </div>

                <IconButton
                  onClick={exitStream}
                  className={classes.btnStyleExit}
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                >
                  <CancelSharpIcon className={classes.exitIcon} />
                </IconButton>
                <Donate
                  open={paymentEle}
                  handleClose={handleCloseDonate}
                  elRefRen={paymentRef}
                />
              </div>
              <CustomModal
                open={dialog}
                setOpen={setDialog}
                onCloseModal={handleShowDialog}
                exitIconCls={classes.exitIcon}
              >
                <div
                  className={classes.layoutRoot}
                  style={{
                    maxHeight: 0.9 * height,
                    maxWidth: 0.9 * width,
                    overflowY: 'scroll',
                    overflowX: 'scroll',
                    backgroundColor: '#2B2C33',
                  }}
                  id='disuniquescrolllimits' //this is used in stadium boxes for taking image back to its initial scroll limits
                >
                  <StadiumBoxes onCloseModal={handleShowDialog} />
                </div>
              </CustomModal>
              <Container style={{ color: '#fff', flex: 1 }}>
                <VideoChat layoutType={1} />
              </Container>
            </Grid>
          </Splitter>
        </Grid>
        <Tour
          onRequestClose={closeTour}
          showNavigation={false}
          steps={tourConfig}
          isOpen={watchEventTour.isTourOpen}
          maskClassName='mask'
          className='helper'
          rounded={5}
          accentColor={accentColor}
          onAfterOpen={disableBody}
          onBeforeClose={enableBody}
          prevButton={
            <CustomButton
              btnStyle={classes.btnStyle}
              btnText={'Prev'}
              startIcon={
                <KeyboardArrowLeftSharpIcon className={classes.changeIcon} />
              }
            />
          }
          nextButton={
            <CustomButton
              btnStyle={classes.btnStyle}
              btnText={'Next'}
              endIcon={
                <KeyboardArrowRightSharpIcon className={classes.changeIcon} />
              }
            />
          }
          lastStepNextButton={
            <CustomButton
              btnStyle={classes.btnStyle}
              btnText={'ok'}
              clickHandle={() => closeTour()}
              endIcon={<CheckCircleSharpIcon className={classes.changeIcon} />}
            />
          }
        />
      </div>
    );
  };

  const renderLayout = () => {
    return regularLayoutFunc();
  };

  return renderLayout();
}

export default Layout;

const tourConfig = [
  {
    selector: '[data-tut="reactour_quality"]',
    content: `You can adjust streaming video resolution here.`,
  },
  {
    selector: '[data-tut="reactour_sound"]',
    content: `You can adjust streaming video sound here.`,
  },
  {
    selector: '[data-tut="reactour_chat"]',
    content: `You can shift between Event & Table chats and also send personalize messages by tagging`,
  },
  {
    selector: '[data-tut="reactour_boxChange"]',
    content: `Click on the table/box number in the seating layout and select seat, to switch table.`,
  },
  {
    selector: '[data-tut="reactour_participant"]',
    content: `You can switch on/off audio and video of a guest sitting with you for yourself.`,
  },
  {
    selector: '[data-tut="reactour_gutter"]',
    content: `You can adjust size of any section by stretching.`,
  },
];
